





































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { DepotDto, ViewedDepot } from "@/common/types/DepotDto";
import {
  DEPOT,
  DEPOT_LOADED,
  DEPOT_STORE,
  DepotFetchParameter,
  FETCH_DEPOT, FETCH_PSBUSER, PSBUSER, PSBUSER_LOADED,
  PSBUSER_LOADING, PsbUserFetchParameter
} from "@/common/store/modules/DepotStore";
import { ADD_LAST_VIEWED_DEPOT } from "@/common/store/modules/CommonStore";
import { PsbUser } from "@/common/types/PsbUser";
import { UserAddress } from '@/common/types/UserAddress';

export default Vue.extend({
  name: 'OctOwnerData',
  data() {
    return {
      itemsPerPage: 4,
      itemsPerPageOptions: [4, 8, 12],
      localUserData: [] as UserAddress[],
      localUser: {
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        street: '',
        zipCode: '',
        city: '',
        countryCode: '',
        linkStatus: 'CREATED'
      } as DepotDto,
      headers: [
        {
          text: this.$t('depot_owner_prop_firstName'),
          value: 'firstName'
        },
        {
          text: this.$t('depot_owner_prop_lastName'),
          value: 'lastName'
        },
        {
          text: this.$t('depot_owner_prop_zipcode'),
          value: 'zipcode'
        },
        {
          text: this.$t('depot_owner_prop_city'),
          value: 'city'
        },
        {
          text: this.$t('depot_owner_prop_street'),
          value: 'street'
        },
        {
          text: this.$t('depot_owner_prop_countryCode'),
          value: 'countryCode'
        },
      ]
    };
  },
  computed: {
    ...mapGetters(DEPOT_STORE, [DEPOT_LOADED, DEPOT, PSBUSER_LOADING, PSBUSER, PSBUSER_LOADED]),
  },
  watch: {
    [DEPOT](newValue: DepotDto, oldValue: DepotDto) {
      if (this.DEPOT_LOADED) {
        this.localUser = { ...newValue };
        this.localUserData.unshift({
          firstName: newValue.firstName,
          lastName: newValue.lastName,
          zipcode: newValue.zipCode,
          street: newValue.street,
          city: newValue.city,
          countryCode: newValue.countryCode,
          highlighted: true
        } as UserAddress);

        this.$store.dispatch(ADD_LAST_VIEWED_DEPOT, {
          id: this.localUser.id,
          email: this.localUser.email
        } as ViewedDepot);
        this.$store.dispatch(FETCH_PSBUSER, { email: this.localUser.email } as PsbUserFetchParameter);
      }
    },
    [PSBUSER](newValue: PsbUser) {
      if (this.PSBUSER_LOADED) {
        this.localUserData = this.localUserData.concat(newValue.addresses.map((psbUser: any) => {
          return {
            firstName: psbUser.firstName,
            lastName: psbUser.lastName,
            zipcode: psbUser.address.zipCode,
            street: psbUser.address.street,
            city: psbUser.address.city,
            countryCode: psbUser.address.countryCode,
            highlighted: false
          } as UserAddress;
        }));
      }
    }
  },
  mounted(): void {
    this.$store.dispatch(FETCH_DEPOT, { id: this.$route.params.id } as DepotFetchParameter);
  }
});
